module.exports = __webpack_public_path__ + "static/media/mobiilivarmenne-ftn.f20de284.svg";